import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ApiRequest = async (method, endpoint, payload = {}) => {
  const getEndpointWithCacheBuster = (url) => {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}_t=${Date.now()}`;
  };

  // Read the token fresh on every request so it works right after login
  // (a module-level constant would stay null until a full page reload)
  const token = localStorage.getItem("AccessTokenTms");

  const headers = {
    headers: {
      "x-access-token": token,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
  };
  try {
    let response = null;
    switch (method) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, headers);
        break;

      case "GET":
        response = await axios.get(BaseUrl + getEndpointWithCacheBuster(endpoint), headers);
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      case "DELETE":
        response = await axios.delete(BaseUrl + endpoint, payload, headers);
        break;

      default:
        throw new Error(`Invalid method: ${method}`);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default ApiRequest;
